module.exports = __webpack_public_path__ + "static/media/allinone_1.42875ef6.svg";